import { getItems } from 'lib/SessionStorage';
import { STORAGE_KEYS } from 'constants/general';
import { RejectionReason, FormattedRejectionReason } from 'data/RejectReasons';

/**
 * Formats an array of raw rejection reasons into dropdown format
 * @param reasons - Array of raw rejection reasons with code and description
 * @returns Array of formatted rejection reasons with id and value
 */
export const formatRejectionReasons = (reasons: RejectionReason[]): FormattedRejectionReason[] => {
  if (!Array.isArray(reasons)) {
    return [];
  }

  return reasons.map((reason: RejectionReason) => ({
    id: reason.code,
    value: `${reason.code} - ${reason.name}`
  }));
};

/**
 * Loads rejection reasons from session storage
 * @returns Array of raw rejection reasons from storage or empty array if not found
 */
export const loadRejectionReasonsFromStorage = (): RejectionReason[] => {
  try {
    const storedReasons = getItems(STORAGE_KEYS.REJECTION_REASONS);
    return Array.isArray(storedReasons) ? storedReasons : [];
  } catch (error) {
    console.error('Failed to load rejection reasons from storage:', error);
    return [];
  }
};